
import { Box, InputLabel, TextField } from "@mui/material";
import styles from './FormToggle.module.scss';
import classNames from 'classnames/bind';
import { getUnit } from "@mui/material/styles/cssUtils";
import { getIn } from "formik";

const cx = classNames.bind(styles);

const FormToggle = (props: {
  text: string;
  form?: any;
  inputkey: string;
  value?: boolean;
  disable?: boolean;
  inputType?: string;
  maxText?: number;
  unit?: string;
  onChange?: (e: any) => void;
  width?: string;
  restrictNumber?: boolean;
  height?: string;
  isViewMode?: boolean;
}) => {
  const {
    text,
    form,
    inputkey,
    value,
    onChange,
    isViewMode,
  } = props;


  const errorMessage = getIn(form?.errors, inputkey);

  const handleInputChange = (e: any) => {
    let newValue = !value;

    if (onChange) {
      if (isViewMode) return;
      onChange({ newValue, target: { ...e.target, value: newValue } });
    }

    if (form) {
      form.setFieldValue(inputkey, newValue);
    }
  };

  return (
    <Box className="w-full" style={{
      height: "14px"
    }}>
      {text && <InputLabel className={cx("form-input-title")}>{text}</InputLabel>}

      <div className={cx({
        'togger-bg': true,
        'view-mode': isViewMode,
        active: value,
      })} onClick={handleInputChange}>
        <div className={cx('togger-circle')} >
          <div className={cx('circle')}></div>
        </div>
      </div>
    </Box>
  );
};

export default FormToggle;
